export class ScrollState {
    public isDown = false;
    public isDragged = false;
    public startX: number | null = null;
    public scrollLeft: number | null = null;
}
export const mousedownEventHandler = (
    scroll: ScrollState,
    event: MouseEvent,
    horizontalScroll: HTMLElement
): void => {
    scroll.isDown = true;
    scroll.startX = event.pageX - horizontalScroll.offsetLeft;
    scroll.scrollLeft = horizontalScroll.scrollLeft;
};
export const mouseupEventHandler = (
    scroll: ScrollState,
    horizontalScroll: HTMLElement
): void => {
    scroll.isDown = false;
    // 마우스 클릭이 끝날 때 a 태그의 기본 이벤트 금지
    if (scroll.isDragged) {
        horizontalScroll.childNodes.forEach((childItem) => {
            childItem.addEventListener('click', _preventClick);
        });
    } else {
        horizontalScroll.childNodes.forEach((childItem) => {
            childItem.removeEventListener('click', _preventClick);
        });
    }
    scroll.isDragged = false;
};
const _preventClick = (event: Event): void => {
    event.preventDefault();
    event.stopImmediatePropagation();
};
export const mouseleaveHandler = (scroll: ScrollState): void => {
    scroll.isDown = false;
};
export const mousemoveHandler = (
    scroll: ScrollState,
    event: MouseEvent,
    horizontalScroll: HTMLElement
): void => {
    if (!scroll.isDown) return;
    event.preventDefault();
    const x = event.pageX - horizontalScroll.offsetLeft;
    const movedX = (x - scroll.startX!) * 1;
    if (Math.abs(movedX) <= 10) {
        scroll.isDragged = false;
    } else {
        scroll.isDragged = true;
    }
    horizontalScroll.scrollLeft = scroll.scrollLeft! - movedX;
};
